export default "__VITE_ASSET__BsZzsBGp__"